import React from "react";
import { DollarSign, Clock, Package, Users } from "lucide-react";

const StatCard = ({ icon: I, label, value }) => (
  <div className="card-industrial p-5">
    <I className="mb-2 text-[var(--accent)]" size={22}/>
    <div className="font-mono text-[10px] tracking-widest text-[var(--ink-2)]">{label}</div>
    <div className="font-display text-3xl">{value}</div>
  </div>
);

export default function OverviewTab({ stats }) {
  if (!stats) return null;
  const max = Math.max(...stats.sales_by_day.map(x => x.total), 0) || 1;
  return (
    <div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-testid="stats-cards">
        <StatCard icon={DollarSign} label="TOTAL SALES" value={`$${stats.total_sales.toFixed(2)}`}/>
        <StatCard icon={Clock} label="PENDING" value={stats.pending_orders}/>
        <StatCard icon={Package} label="PRODUCTS" value={stats.total_products}/>
        <StatCard icon={Users} label="CUSTOMERS" value={stats.total_customers}/>
      </div>
      <div className="card-industrial p-6">
        <h3 className="font-display text-2xl mb-4">SALES · LAST 14 DAYS</h3>
        <div className="flex items-end gap-2 h-40 border-b-2 border-[var(--ink)] pb-2">
          {stats.sales_by_day.length === 0 ? (
            <div className="w-full text-center font-mono text-sm">No sales yet.</div>
          ) : stats.sales_by_day.map(d => (
            <div key={d.day} className="flex-1 flex flex-col items-center gap-1">
              <div className="font-mono text-[9px]">${d.total.toFixed(0)}</div>
              <div className="w-full bg-[var(--accent)] border border-[var(--ink)]" style={{height: `${(d.total/max)*100}%`}}/>
              <div className="font-mono text-[9px]">{d.day.slice(5)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
